<template>
  <div class="satd-saisies-add">

    <div class="satd-saisies-add__subheader">
      <ui-link-button-meek
        :size="UI.SIZE.SMALL"
        :route="parentRoute"
        bulky
      >
        <ui-icon
          name="navigate_before"
        />
        Saisies
      </ui-link-button-meek>
    </div>

    <div class="satd-saisies-add__card">
      <form-organism
        v-bind="{
          mode: MODE.CREATION,
          submitCallback: createCallback,
          cancelCallback: onCancel,
          loadSalarieOptions,
          isPending,
        }"
      />
    </div>

  </div>
</template>

<style lang="sass" scoped>
@import ~/assets/sass/modules/layout/variables

.satd-saisies-add
  background-color: $background-tertiary
  min-height: 100vh

  &__subheader
    padding: ($layout-spacer-y * .75) $layout-spacer-x 0

  &__card
    padding: space-x(2) $layout-spacer-x
    margin-top: space-x(2)
</style>

<script lang="ts">
import { useCompanyRequiredNavigationContext } from '~/composables/layout/navigation'
import { getSaisiesRoute } from '~/stores/satd'
import { useStore_satd_saisies_create } from '~/stores/satd/saisies/create'
import { useToastBuilder } from '~/composables/layout/toast'
import { toString } from '~/utils/lib/core/prelude'
import { NAVIGATION_SCOPE } from '~/utils/lib/layout/types'
import FormOrganism, { MODE } from '~/components/satd/saisies/form/Organism.vue'
import { useLinkHandler } from '~/composables/core/link-handler'
import { useStore_satd_saisies_list_salarie } from '~/stores/satd/saisies/list/salarie'

export default defineNuxtComponent({
  components: { FormOrganism },
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.COMPANY_REQUIRED,
    })
    const navigationContext = useCompanyRequiredNavigationContext()
    const store_satd_saisies_create = useStore_satd_saisies_create()
    const store_satd_salarie = useStore_satd_saisies_list_salarie()
    const ToastBuilder = useToastBuilder()

    return {
      ...navigationContext,
      ...useLinkHandler(),
      store_satd_saisies_create,
      store_satd_salarie,
      ToastBuilder,
    }
  },
  data() {
    return {
      MODE,
      isPending: false,
    }
  },
  computed: {
    parentRoute() {
      const {
        structure: { id },
        company: { code_societe }
      } = this.fromCompanyLevel()
      return getSaisiesRoute(id, code_societe)
    },
  },
  methods: {
    loadSalarieOptions(search: string) {
      const {
        structure: { uuidData },
        company: { societeId }
      } = this.fromCompanyLevel()

      return this.store_satd_salarie.search({
        search,
        uuidData,
        societeId,
      })
    },
    onCancel() {
      const {
        structure: { id: structure_id },
        company: { code_societe }
      } = this.fromCompanyLevel()
      this.goToRoute(getSaisiesRoute(structure_id, code_societe))
    },
    createCallback(payload: Record<string, unknown>) {
      const {
          structure: { id: structure_id, uuidData },
          company: { code_societe, societeId }
        } = this.fromCompanyLevel()
      this.isPending = true
      return this.store_satd_saisies_create.create(
        {
          uuidData,
          societeId,
          ...payload
        } as Parameters<typeof this.store_satd_saisies_create.create>[0]
      ).then(() => {
          this.
            ToastBuilder
            .success('Saisie ajoutée avec succès')
            .title('Saisie ajoutée avec succès')
            .show()
          this.goToRoute(getSaisiesRoute(structure_id, code_societe))
        })
        .catch((err) => {
          this.
            ToastBuilder
            .error(toString(err))
            .title('Erreur lors de l\'ajout de la saisie')
            .show()
        })
        .finally(() => {
          this.isPending = false
        })
    },
  },
})
</script>
